export default {
  DELIVERED: 'delivered',
  DELIVERED_OUTSIDE: 'delivered_outside',
  DELETED: 'deleted',
}
